function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import axios from 'axios';
var __AQE_INTERNALS__ = {};

function validateInternals() {
  if (!Object.keys(__AQE_INTERNALS__).length) {
    throw new Error('[aqe] configuration has not been set');
  }

  if (!__AQE_INTERNALS__.appName) {
    throw new Error('[aqe] appName is required');
  }
}

var Aqe = /*#__PURE__*/function () {
  function Aqe() {
    _classCallCheck(this, Aqe);
  }

  _createClass(Aqe, [{
    key: "set",
    value: function set(configOrKey, value) {
      if (value && typeof configOrKey === 'string') {
        __AQE_INTERNALS__[configOrKey] = value;
      } else {
        Object.assign(__AQE_INTERNALS__, configOrKey);
      }

      return this;
    }
  }, {
    key: "defaults",
    get: function get() {
      validateInternals();
      return _objectSpread({}, __AQE_INTERNALS__);
    }
  }, {
    key: "useAxiosInterceptor",
    value: function useAxiosInterceptor(type, onFulfilled, onRejected) {
      return axios.interceptors[type].use(onFulfilled, onRejected);
    }
  }, {
    key: "ejectAxiosInterceptor",
    value: function ejectAxiosInterceptor(type, id) {
      axios.interceptors[type].eject(id);
    }
  }]);

  return Aqe;
}();

var aqe = new Aqe();
export default aqe;